import img1 from '../../static/img/class_types_page/MoveIt_Low_Impact_Dance_Fitness_1.webp';
import img2 from '../../static/img/class_types_page/MoveIt_Low_Impact_Dance_Fitness_2.webp';
import quoteImg from '../../static/img/class_types_page/MoveIt_Low_Impact_Dance_Fitness_3.webp';

const Class = {
  code: 'moveit',
  name: 'The Move It Class',
  sentence1: 'Using Nia’s 52 moves, this revolutionary approach to whole body fitness integrates science, modern interval training, music and lots of fun to deliver whole-body conditioning in 60 minutes.',
  sentence2: '',
  quoteSentence1: 'Amazing experience, mind, body and soul!!! I love Nia and everything about it... I leave feeling grounded with my heart open and my body smiling!',
  quoteAttr: 'Michelle A., Nia Student',
  img1,
  img2,
  quoteImg,
  img1Alt: 'A person in a black top dancing and smiling during a Nia low impact dance fitness class',
  img2Alt: 'A person in a green tank top dancing and smiling during a Nia low impact dance fitness class',
  quoteAlt: 'A quote that says "The art of conditioning" in orange script writing, illustrating how active Nia\'s low impact dance fitness classes are',
};

export default Class;
